<template>
  <div class="project-autopilots">
    <div class="project-autopilots-left">
      <div class="project-autopilots-left-head">
        <!-- Page Title -->
        <TText
          text="Autopilots"
          font_weight="500"
          size="32"
        />

        <!-- Navigation -->
        <div class="project-autopilots-left-navigation">
          <!-- TO AUTOPILOTS SETTINGS LANDING PAGE -->
          <!-- NOTE: throw this away, when it stays empty -->
          <!-- <v-btn
            icon
            large
            @click="$router.push({name: 'ProjectAutoPilots'})"
          >
            <v-icon>mdi-home-search</v-icon>
          </v-btn> -->

          <!-- TO AUTOPILOT ADD PAGE -->
          <v-btn
            icon
            large
            @click="$router.push({name: 'ProjectAutoPilotsAdd'})"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- List of Autopilots -->
      <div
        class="project-autopilots-list"
        v-for="autopilot_type in autopilots"
        :key="autopilot_type.type"
      >
        <!-- Head of Category-List -->
        <div class="project-autopilots-list-head">
          <!-- Name of Autopilot Category -->
          <div class="project-autopilots-list-head-description">
            {{ autopilot_type.type }}
          </div>

          <!-- Level Descriptor for Level Matrix -->
          <FillableCell
            v-for="n in 4"
            :key="`${autopilot_type.type}-level-description-${n}`"
            :height="cell_height"
            :width="cell_width"
          >
            <template #content>
              {{ n }}
            </template>
          </FillableCell>
        </div>

        <!-- List Elements in Category -->
        <div
          v-for="autopilot in autopilot_type.autopilotprojects"
          :key="autopilot.id"
          class="project-autopilots-list-element"
          @click="$route.params.autopilot_id !== autopilot.id
            ? $router.push({
                name: 'ProjectAutoPilotsDetails',
                params: {autopilot_id: autopilot.id}
              })
            : ''"
        >
          <!-- Line -->
          <div class="project-autopilots-list-element-line"/>
          <!-- Actual List Item -->
          <div class="project-autopilots-list-element-content">

            <!-- Left Side (Head) -->
            <div class="project-autopilots-list-element-head">
              <!-- Autopilot Name -->
              <TText
                :text="autopilot.mapped_autopilot.function"
              />

              <!-- 2nd row: play/pause button and issue counts -->
              <TFlex align_items="center">
                <!-- Play/Pause -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <!-- Icon-Button -->
                    <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="updateUObject({
                      url: [
                      {projects: project.id},
                      {autopilotprojects: autopilot.id}
                      ],
                      update: {
                        active: !autopilot.active
                      }
                      })"
                      >
                      <v-icon>
                        {{ autopilot.active ? 'mdi-play' : 'mdi-pause'}}
                      </v-icon>
                    </v-btn>
                  </template>

                  <!-- Tooltip -->
                  <span>
                    {{ autopilot.active ? 'currently active' : 'currently paused' }}
                  </span>
                </v-tooltip>

                <!-- TODO: Issue Count -->
                <span> {{ getAutopilotissuesCount(autopilot) }} issues </span>
              </TFlex>
            </div>

            <!-- Right Side (Radio Button Matrix) -->
            <RadioKnobRow
              :knobs="autopilot.levels"
              :selected_id="autopilot.mapped_autopilot.id"
              :cell_count="4"
              :is_disabled="!autopilot.active"
              :height="cell_height"
              :width="cell_width"
              @knobClicked="
                autopilot.mapped_autopilot.id !== level.id ?
                updateUObject({
                  url: [
                  {projects: project.id},
                  {autopilotprojects: autopilot.id}
                  ],
                  update: {
                    ['add#autopilots']: [level.id]
                  }
                }).then(() => {
                  updateUObject({
                    url: [
                    {projects: project.id},
                    {autopilotprojects: autopilot.id}
                    ],
                    update: {
                      ['remove#autopilots']: [autopilot.autopilots[0]]
                    }
                  })
                  })
                :
                ''"
            />

            <!-- Level Selection -->
            <!-- <v-btn
              v-for="level in autopilot.levels"
              :key="`aplevel${level.id}`"
              small
              class="ml-1"
              :color="autopilot.mapped_autopilot.id === level.id?'green':''"
              @click="
                autopilot.mapped_autopilot.id !== level.id?
                updateUObject({
                  url: [
                  {projects: project.id},
                  {autopilotprojects: autopilot.id}
                  ],
                  update: {
                    ['add#autopilots']: [level.id]
                  }
                }).then(() => {
                  updateUObject({
                    url: [
                    {projects: project.id},
                    {autopilotprojects: autopilot.id}
                    ],
                    update: {
                      ['remove#autopilots']: [autopilot.autopilots[0]]
                    }
                  })
                  })
                :
                ''
              "
            >
              {{ level.level }}
            </v-btn> -->
          </div>

        </div>
      </div>

      <TText
        class="project-autopilots-left-hint"
        v-if="autopilots.length == 0"
        text="No autopilots added yet."
      />
    </div>

    <div class="project-autopilots-right">
      <router-view/>
      <div v-if="$route.name === 'ProjectAutoPilots'">
        <!-- ALL ISSUES -->
        <TText
          text="Issues"
          font_weight="500"
          size="32"
        />
        <TFlex wrap="wrap">
          <v-card
            v-for="issue in getUObjects({ type: 'autopilotissues' })"
            :key="`issue${issue.id}`"
            class="ma-2"
            :color="issue.parent.color"
            :style="`color: ${issue.parent.textcolor}`"
            max-width="344"
          >
          <div v-if="issue.parent_type === 'twork_package'">
            <WorkPackageHead
              :head="{
                token: issue.parent.token,
                name: issue.parent.name,
                icon: issue.parent.icon,
                area: issue.parent.taktarea_name,
                status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === issue.parent.status),
                status_is_stop: issue.parent.stop_status,
              }"
              :foreground_color="getColor(issue.parent.textcolor)"
              :readonly="true"
              />
            <!-- <v-card-title></v-card-title> -->
            <v-card-subtitle>ISSUE.status: <b>{{ issue.status }}</b></v-card-subtitle>
            <v-card-text>
              {{ issue.logentries[0].value }}
            </v-card-text>
              <v-card-actions>
                <v-btn @click="updateUObject({
                  url: [
                    { projects: project_id },
                    { autopilotissues: issue.id },
                  ],
                  update: { status: issue.status === 'resolved' ? 'open' : 'resolved' }
                  })"
                >
                    {{ issue.status === 'resolved' ? 'reopen' : 'resolve' }}
                </v-btn>
                <v-btn @click="routeToParent(issue)">go to work package</v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </TFlex>
      </div>
    </div>
  </div>
</template>

<script>
  import {  mapGetters, mapActions } from 'vuex';
  import TText from '@/components/Taktify/TText.component.vue';
  import RadioKnobRow from '@/modules/WorkPackageWIP/RadioKnobRow.module.vue';
  import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';
  import FillableCell from '@/components/WorkPackageWIP/FillableCell.component.vue';
  import TFlex from '@/components/Taktify/TFlex.component.vue';
  import { TColor } from '@/mixins/TColor.mixin.js'

  export default {
    components: {
      TText,
      RadioKnobRow,
      FillableCell,
      TFlex,
      WorkPackageHead
    },
    mixins: [TColor],

    props: [],

    data: () => ({
      cell_height: 32,
      cell_width: 64,
    }),

    created() {
      this.requestUObject({
        url: [
          {autopilots: ''},
          {showWithEntitiesNormalized: ''}
        ]
      });
      this.requestUObject({
        url: [
          {projects: this.project.id},
          {autopilotprojects: ''},
          {showWithEntitiesNormalized: ''}
        ],
        add_u_object: true
      });
      this.requestUObject({
        url: [
          {projects: this.project.id},
          {autopilotissues: ''},
          {showWithEntitiesNormalized: ''}
        ]
      });

    },

    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapGetters('AutopilotRework', [
        'getAutopilotProjects',
      ]),
      project() {
        return this.$store.state.Ultra.projects[this.$route.params.project_id];
      },

      autopilots() {
        return this.getAutopilotProjects(this.project.autopilotsprojects);
      },
    },

    methods: {
      ...mapActions('Ultra', [
        'requestUObject',
        'createUObject',
        'updateUObject',
        'deleteUObject'
      ]),

      getAutopilotissuesCount(autopilot){
        let self = this;
        return self.getUObjects({type: 'autopilotissues'}).filter(issue => {
          return issue.autopilot.function === autopilot.mapped_autopilot.function;
        }).length;
      },
    }
  }
</script>

<style>
  .project-autopilots {
    display: flex;
  }
  .project-autopilots-left-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .project-autopilots-left-navigation {
    display: flex;
    grid-gap: 8px;
  }
  .project-autopilots-left-hint {
    padding-top: 32px;
  }
  .project-autopilots-left {
    /* width: max(33%, 500px); */
    width: 500px;
    flex-shrink: 0;
    background-color: var(--v-color-2-5-base);
    padding: 24px;
  }
  .project-autopilots-right {
    height: 100%;
    margin: 16px;
    overflow: auto;
  }
  .project-autopilots-list-element-line {
    width: 100%;
    height: 0;
    border-top: 1px solid;
    border-color: var(--v-primary-base);
    opacity: .5;
    margin: 10px 0;
    display: flex;
    align-self: center;
  }
  .project-autopilots-list-element-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .project-autopilots-list-element-head {
    display: flex;
    flex-direction: column;
    grid-gap: 4px;
    width: 100%;
  }
  .project-autopilots-list-element {
    width: 100%;
    cursor: pointer;
    /* margin: 10px 0; */
  }
  .project-autopilots-list-head-description {
    display: flex;
    flex-grow: 1;
  }
  .project-autopilots-list-head {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .project-autopilots-list {
    padding-bottom: 16px;
  }
</style>
